import { createAction, props } from '@ngrx/store';

export const updateProduct = createAction('[Product] update product', props<{product: any}>());
